import React, {
  useState,
  useEffect
} from 'react';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';

import { useIsMobile } from '../../../../recoil';
import { useTealium } from '../../../../tealium/useTealium';
import styles from './applications.module.css';
import { ApplicationAccordion } from './ApplicationAccordion';

export const Applications = ({ listApplication, businessNameForApp }) => {

  const isMobile = useRecoilValue(useIsMobile);
  const { track, events } = useTealium();
  const [openAccordion, setOpenAccordion] = useState('');

  useEffect(() => {
    track(events.applications.pageView());
  }, []);

  useEffect(() => {
    if (listApplication && listApplication.length > 0) {
      track(events.applications.viewApplicationDetails());
    }
  }, [listApplication]);

  const handleAccordionToggle = (applicationId) => {
    if (openAccordion === `app${applicationId}`) {
      setOpenAccordion('');
    } else {
      track(events.applications.viewApplicationDetails());
      setOpenAccordion(`app${applicationId}`);
    }
  };

  return (
    <div className={styles.rightWrapper}>
      <div className={styles.rightHeading}>
        <div className={isMobile ? styles.titleHeadingMobile : styles.titleHeading}>

          My applications
        </div>
      </div>

      <div className={isMobile ? styles.accordionSectionMobile : styles.accordionSection}>
        {(listApplication && (listApplication?.length > 0)) &&
          listApplication?.map((application) => (
            <ApplicationAccordion
              key={`app${application.applicationId}`}
              isOpen={openAccordion === `app${application.applicationId}`}
              toggleOpen={() => handleAccordionToggle(application.applicationId)}
              applicationData={application}
              businessNameForApp={businessNameForApp}
            />
          ))}
      </div>
    </div>
  );
};
Applications.propTypes = {
  listApplication: PropTypes.array,
  businessNameForApp: PropTypes.string
};
